import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCustomerProfile } from "../../api";
import styles from "./CustomerProfile.module.css";

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};
const phoneNumber = "971503469515";
const openWhatsApp = () => {
  const url = `https://wa.me/${phoneNumber}`;
  window.open(url, "_blank", "noopener,noreferrer");
};
const accountOptions = [
  {
    title: "Your Bookings",
    description: "View and manage your racket stringing bookings",
    icon: "📦",
    path: "/customer/dashboard/booking-list",
  },
  {
    title: "Login & Security",
    description: "Update your mobile number",
    icon: "🔒",
    path: "/customer/dashboard/edit-info",
  },
  {
    title: "Your Addresses",
    description: "Edit addresses for orders and gifts",
    icon: "📍",
    path: "/customer/dashboard/edit-address",
  },
  {
    title: "Contact Us",
    description: "Contact our customer service via phone or chat",
    icon: "🎧",
    onClick: openWhatsApp,
  },
];

const CustomerProfile = () => {
  const [profile, setProfile] = useState(null);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getCustomerProfile();
        setProfile(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  if (!profile) {
    return <div className={styles.loading}>Loading...</div>;
  }

  return (
    <div className={styles.profileContainer}>
      <h2 className={styles.heading}>Your Account</h2>

      <div className={styles.profileBox}>
        <p>
          <strong>Name:</strong> {profile.first_name} {profile.last_name}
        </p>
        <p>
          <strong>Email:</strong> {profile.email}
        </p>
        <p>
          <strong>Phone No:</strong> {profile.phone}
        </p>
      </div>

      {/* Coach Section */}
      {profile.is_coach && (
        <div className={styles.coachSection}>
          <div className={styles.coachHeader}>
            <h3 className={styles.coachTitle}>🎾 Coach Partnership Program</h3>
            <span className={styles.coachBadge}>{profile.coach_status || 'active'}</span>
          </div>

          <div className={styles.coachCouponBox}>
            <label className={styles.coachLabel}>Your Personal Coupon Code</label>
            <div className={styles.couponCodeDisplay}>
              <span className={styles.couponCode}>{profile.coach_coupon_code || 'Loading...'}</span>
              <button
                className={styles.copyButton}
                onClick={() => {
                  copyToClipboard(profile.coach_coupon_code);
                  setCopied(true);
                  setTimeout(() => setCopied(false), 2000);
                }}
                title="Copy to clipboard"
              >
                {copied ? "✓ Copied!" : "📋 Copy"}
              </button>
            </div>
          </div>

          <div className={styles.coachStatsGrid}>
            <div className={styles.statCard}>
              <div className={styles.statValue}>{profile.coach_credits_available || 0}</div>
              <div className={styles.statLabel}>Available Credits</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statValue}>{profile.coach_credits_earned || 0}</div>
              <div className={styles.statLabel}>Total Earned</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statValue}>{profile.coach_credits_used || 0}</div>
              <div className={styles.statLabel}>Credits Used</div>
            </div>
          </div>

          <div className={styles.coachInstructions}>
            <h4 className={styles.instructionsTitle}>How to Use Your Coupon</h4>
            <ol className={styles.instructionsList}>
              <li>Share your coach referral link with others</li>
              <li>When they make a purchase of 750 AED or more, you earn 1 free stringing credit</li>
              <li>Credits are granted 15 days after the order is placed</li>
              <li>Book a stringing service and enter your coupon code at checkout</li>
              <li>Enjoy a free service fee (75 AED off per credit)!</li>
            </ol>
          </div>
        </div>
      )}

      <div className={styles.grid}>
        {accountOptions.map((option, idx) => (
          <div
            key={idx}
            className={styles.card}
            role="button"
            tabIndex={0}
            onClick={() =>
              option.onClick ? option.onClick() : navigate(option.path)
            }
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                option.onClick ? option.onClick() : navigate(option.path);
              }
            }}
          >
            <div className={styles.icon}>{option.icon}</div>
            <div>
              <h3 className={styles.title}>{option.title}</h3>
              <p className={styles.description}>{option.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerProfile;
